<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="pa-2">
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="cyan"
        ></v-progress-linear>
        <v-row v-else>
          <v-col v-for="(space, i) in spaces" :key="i" cols="12">
            <v-card
              height="80px"
              class="d-flex border align-items-center"
              rounded="xxl"
              elevation="0"
            >
              <v-card-text
                style="cursor: pointer"
                @click="
                  editSpace = true;
                  oneTab = i;
                  category = space;
                "
              >
                <v-card-title>{{ space.name }}</v-card-title>
              </v-card-text>
              <v-card-action
                style="gap: 10px"
                class="d-flex mx-3 gap-2 align-items-center"
              >
                <v-icon
                  @click="
                    deleteSpaceOne(space.id);
                    category = space;
                  "
                  style="cursor: pointer"
                  >mdi-delete</v-icon
                >
                <v-icon
                  @click="
                    editSpace = true;
                    oneTab = i;
                    category = space;
                  "
                  style="cursor: pointer"
                  >mdi-pencil</v-icon
                >
              </v-card-action>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-btn
              @click="addSpace = true"
              outlined
              color="primary"
              class="w-100"
            >
              <v-icon>mdi-plus</v-icon>
              افزودن دسته تبلیغاتی
            </v-btn>
          </v-col>
        </v-row>

        <!-- add one  space  -->
        <custom-popup
          :cons="{ title: 'افزودن دسته بندی تبلیغاتی' }"
          v-model="addSpace"
          maxWidth="500px"
          @action="addSpaceFun"
        >
          <div class="pa-2">
            <v-text-field
              :label="labelMessageTab"
              v-model="nameSpace"
              append-icon="mdi-pencil"
              hint="مثال : آسانسور"
              outlined
              @focus="labelMessageTab = 'دسته بندی'"
              @blur="
                labelMessageTab = ' نام دسته بندی تبلیغاتی خود را وارد کنید'
              "
            >
            </v-text-field>

            <pic-selector
              :edit-img="false"
              :edit-name="false"
              :field.sync="picture"
              default-cat-name="دسته‌بندی‌ها"
              one-pic
              single
            />
          </div>
        </custom-popup>
        <!-- add two space -->
        <custom-popup
          v-model="editSpace"
          :hideClose="e1 == 2 ? true : false"
          :hideConfirm="e1 == 2 ? true : false"
          :persistent="e1 == 2 ? true : false"
          maxHeight="420px"
          :cons="{
            title:
              e1 == 2
                ? 'ویرایش / افزودن فضای تبلیغاتی'
                : 'افزودن فضای تبلیغاتی',
          }"
        >
          <v-stepper v-model="e1">
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card elevation="0" class="pa-2">
                  <!-- one space tab -->
                  <v-tabs v-model="oneTab">
                    <v-tab
                      v-for="(space, i) in spaces"
                      :key="i"
                      class="d-flex align-items-center"
                      @click="category = space"
                    >
                      <v-img
                        width="30"
                        height="30"
                        style="border-radius: 100%"
                        v-if="space.image"
                        :src="space.image"
                      />
                      <h3 class="mx-2" style="margin: 0">{{ space.name }}</h3>
                    </v-tab>
                  </v-tabs>
                  <!-- one space item -->
                  <v-tabs-items v-model="oneTab" class="pa-2">
                    <!--two space tabs  -->
                    <v-tab-item v-for="(space, i) in spaces" :key="i">
                      <custom-tabs v-model="customtabempty" grow>
                        <template v-slot:staticTabs>
                          <v-tab :ripple="false">
                            <div
                              class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                              style="
                                justify-content: center !important;
                                align-items: center;
                              "
                            >
                              <div class="cornel-left" />
                              <div class="cornel-right" />
                              <v-icon class="me-2"
                                >mdi-view-grid-outline</v-icon
                              >
                              فضاهای تبلیغاتی
                              <help-info
                                :element-name="`${serviceName}-${componentName}-shops-tab`"
                                :service-name="serviceName"
                                :help-data="helpData"
                                class="buttoninfo"
                                label="تعیین اجاره"
                              />
                            </div>
                          </v-tab>
                          <v-tab :ripple="false">
                            <div
                              class="d-flex row gap-0 align-center align-self-center align-items-center px-2"
                              style="
                                justify-content: center !important;
                                align-items: center;
                              "
                            >
                              <div class="cornel-left" />
                              <div class="cornel-right" />
                              <v-icon class="me-2">mdi-pencil</v-icon>
                              ویرایش دسته تبلیغاتی
                              <help-info
                                :element-name="`${serviceName}-${componentName}-edit-roof-tab`"
                                :service-name="serviceName"
                                :help-data="helpData"
                                class="buttoninfo"
                                label="ویرایش طبقه"
                              />
                            </div>
                          </v-tab>
                        </template>
                        <template v-slot:middle></template>
                        <template v-slot:staticItems>
                          <v-tab-item>
                            <v-row class="pa-2">
                              <v-col cols="12">
                                <v-btn
                                  @click="onStepperNewItem(space)"
                                  outlined
                                  color="green"
                                  class="w-100"
                                >
                                  <!-- addSpace2 = true;
                                    spaceId = space.id; -->
                                  <v-icon>mdi-plus</v-icon>
                                  افزودن فضای تبلیغاتی
                                </v-btn>
                              </v-col>
                              <v-col
                                v-for="(item, i) in space.items"
                                :key="i"
                                cols="12"
                                md="6"
                              >
                                <v-card>
                                  <v-card-item>
                                    <v-img
                                      :src="
                                        item?.image?.length > 0
                                          ? item.image
                                          : 'https://www.bahmansport.com/media/com_store/images/empty.png'
                                      "
                                      style="width: 100%; height: 250px"
                                    >
                                    </v-img>
                                  </v-card-item>
                                  <v-card-title class="text-center">{{
                                    item.name
                                  }}</v-card-title>
                                  <v-card-action class="w-100">
                                    <v-btn
                                      @click="
                                        e1 = 2;
                                        editItem = {
                                          id: item?.id,
                                          pay: item?.pay,
                                          active: item?.active,
                                          information: item?.information,
                                          name: item?.name,
                                          image: item?.image,
                                        };
                                      "
                                      class="w-100"
                                    >
                                      ویرایش
                                      <v-icon>mdi mdi-pencil</v-icon>
                                    </v-btn>
                                  </v-card-action>
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-tab-item>
                          <v-tab-item>
                            <v-card elevation="0" class="pa-4">
                              <v-col
                                cols="12"
                                class="d-flex justify-content-start"
                              >
                                <v-btn
                                  @click="editName"
                                  class=""
                                  :loading="loading"
                                  outlined
                                  color="green"
                                  >ثبت تغییرات</v-btn
                                >
                              </v-col>
                              <v-col style="padding: 0" cols="12">
                                <v-text-field
                                  v-model="space.name"
                                  outlined
                                  label="ویرایش نام دسته تبلیغاتی"
                                />
                              </v-col>
                              <v-col style="padding: 0" cols="12">
                                <span class="mb-2"
                                  >ویرایش عکس دسته تبلیغاتی</span
                                >
                                <pic-selector
                                  :edit-img="false"
                                  :edit-name="false"
                                  :field.sync="space.image"
                                  default-cat-name="دسته‌بندی‌ها"
                                  one-pic
                                  single
                                />
                              </v-col>
                            </v-card>
                          </v-tab-item>
                        </template>
                      </custom-tabs>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-stepper-content>
              <v-stepper-content :loading="loading" step="2">
                <div
                  class="w-full d-flex justify-content-end align-items-center"
                >
                  <v-btn
                    @click="fetchToSpace"
                    :loading="loading"
                    :disabled="loading"
                    outlined
                    color="green"
                    >ثبت تغییرات
                    <v-icon>mdi-content-save-check-outline</v-icon>
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    :disabled="loading"
                    @click="e1 = 1"
                    class="mx-2"
                    outlined
                    color="red"
                  >
                    بازگشت
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </div>
                <v-card elevation="0" class="pa-2">
                  <v-col style="padding: 0" cols="12">
                    <v-text-field
                      v-model="editItem.name"
                      outlined
                      label=" نام فضای تبلیغاتی"
                    />
                  </v-col>
                  <v-col style="padding: 0" cols="12">
                    <span style="margin-bottom: 10px"> عکس فضای تبلیغاتی</span>
                    <pic-selector
                      :edit-img="false"
                      :edit-name="false"
                      :field.sync="editItem.image"
                      default-cat-name="دسته‌بندی‌ها"
                      one-pic
                      single
                    />
                  </v-col>
                </v-card>
                <v-card class="pa-2" elevation="0">
                  <v-col class="pa-2" cols="12">
                    <v-switch
                      v-model="editItem.active"
                      :label="editItem.active ? 'فعال' : 'غیرفعال'"
                    ></v-switch>
                  </v-col>

                  <div v-if="editItem.active">
                    <v-col cols="12">
                      <v-text-field
                        v-model="editItem.information.size"
                        label="متراژ"
                        hint="متر مربع/سایز / طول + عرض"
                        outlined
                        append-icon="mdi-arrow-split-vertical"
                        dense
                        :rules="[
                          (v) => v.length > 0 || 'مقدار نمیتواند خالی باشد',
                        ]"
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="editItem.information.rentDay"
                        label="مدت زمان اجاره"
                        hint="حداقل زمان مدت اجاره (روزانه)"
                        outlined
                        append-icon="mdi-calendar-today"
                        dense
                        type="number"
                        :rules="[
                          (v) =>
                            v > 0 || 'مقدار نمیتواند خالی یا کمتر از ۱  باشد',
                        ]"
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-textarea
                        v-model="editItem.information.discription"
                        label="توضیحات"
                        outlined
                        append-icon="mdi-pencil"
                        dense
                        type="number"
                        :rules="[
                          (v) =>
                            v > 0 || 'مقدار نمیتواند خالی یا کمتر از ۱  باشد',
                        ]"
                      />
                    </v-col>

                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <price-input
                          v-model="editItem.pay.day"
                          class="rounded-lg contentinfo"
                          :lazyRules="true"
                          :error="
                            rulesSetting('day', editItem.pay.day, editItem.pay)
                              ? [
                                  rulesSetting(
                                    'day',
                                    editItem.pay.day,
                                    editItem.pay,
                                  ),
                                ]
                              : null
                          "
                          clearable
                          type="number"
                          dense
                          label="هزینه روزانه"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-maxCount`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="هزینه روزانه"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <price-input
                          v-model.number="editItem.pay.week"
                          class="rounded-lg contentinfo"
                          clearable
                          dense
                          label="هزینه هفتگی"
                          outlined
                          :error="
                            rulesSetting(
                              'week',
                              editItem.pay.week,
                              editItem.pay,
                            )
                              ? [
                                  rulesSetting(
                                    'week',
                                    editItem.pay.week,
                                    editItem.pay,
                                  ),
                                ]
                              : null
                          "
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-number-perDayPrice-1w`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="هزینه هفتگی"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <price-input
                          v-model.number="editItem.pay.month"
                          class="rounded-lg"
                          clearable
                          dense
                          label="هزینه ماهانه"
                          outlined
                          :error="
                            rulesSetting(
                              'month',
                              editItem.pay.month,
                              editItem.pay,
                            )
                              ? [
                                  rulesSetting(
                                    'month',
                                    editItem.pay.month,
                                    editItem.pay,
                                  ),
                                ]
                              : null
                          "
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-number-perDayPrice-1m`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="هزینه ماهانه"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <price-input
                          v-model.number="editItem.pay.threeMonth"
                          :error="
                            rulesSetting(
                              'threeMonth',
                              editItem.pay.threeMonth,
                              editItem.pay,
                            )
                              ? [
                                  rulesSetting(
                                    'threeMonth',
                                    editItem.pay.threeMonth,
                                    editItem.pay,
                                  ),
                                ]
                              : null
                          "
                          class="rounded-lg"
                          clearable
                          dense
                          label="هزینه سه‌ماهه"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-number-perDayPrice-3m`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="هزینه سه‌ماهه"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <price-input
                          v-model.number="editItem.pay.sixMonth"
                          :error="
                            rulesSetting(
                              'sixMonth',
                              editItem.pay.sixMonth,
                              editItem.pay,
                            )
                              ? [
                                  rulesSetting(
                                    'sixMonth',
                                    editItem.pay.sixMonth,
                                    editItem.pay,
                                  ),
                                ]
                              : null
                          "
                          class="rounded-lg"
                          clearable
                          dense
                          label="هزینه شیش‌ماهه"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-number-perDayPrice-6m`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="هزینه شیش‌ماهه"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12">
                      <div class="rowinfo">
                        <price-input
                          v-model.number="editItem.pay.year"
                          :error="
                            rulesSetting(
                              'year',
                              editItem.pay.year,
                              editItem.pay,
                            )
                              ? [
                                  rulesSetting(
                                    'year',
                                    editItem.pay.year,
                                    editItem.pay,
                                  ),
                                ]
                              : null
                          "
                          class="rounded-lg contentinfo"
                          clearable
                          dense
                          label="هزینه یک‌ساله"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-number-perDayPrice-1y`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          label="هزینه یک‌ساله"
                        />
                      </div>
                    </v-col>
                  </div>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </custom-popup>

        <!-- add zspace -->
        <custom-popup
          :cons="{ title: 'افزودن  فضای تبلیغاتی' }"
          v-model="addSpace2"
          maxWidth="400px"
          @action="addZSpaceFun"
        >
          <div class="pa-2">
            <v-text-field
              :label="labelMessageSpace"
              @focus="labelMessageSpace = ' فضای تبلیغاتی'"
              @blur="labelMessageSpace = 'نام فضای تبلیغاتی خود را وارد کنید'"
              hint="مثال:آسانسور شماره ۲"
              v-model="nameSpaceTwo"
              outlined
              append-icon="mdi-pencil"
            >
            </v-text-field>

            <pic-selector
              :edit-img="false"
              :edit-name="false"
              :field.sync="picture"
              default-cat-name="دسته‌بندی‌ها"
              one-pic
              single
            />
          </div>
        </custom-popup>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import priceInput from "@/view/pages/uiBeautifier/priceInput";
import picSelector from "../../../../components/UploadCenter/picSelector.vue";

export default {
  name: "advertiseSpace",

  props: {
    value: String,
  },

  components: { priceInput, picSelector },

  data() {
    return {
      // help
      helpData: [],
      serviceName: "Qrland",
      componentName: "advertiesSpace",
      spaces: [],
      // modal
      addSpace: false, //open pop up
      editSpace: false, //open edit popup
      addSpace2: false,
      // string names
      nameSpace: "",
      nameSpaceTwo: "", //name of one space
      //tabs
      oneTab: null,
      twoTab: null,
      customtab: null, //edit tabs name
      customtabempty: null, //edit tabs name empty

      // set id for function
      spaceId: null,
      zSpaceId: null,

      // image
      picture: "",

      // step
      e1: 1,
      // edit itam
      editItem: {},

      // label message
      labelMessageTab: " نام دسته بندی تبلیغاتی خود را وارد کنید",
      labelMessageSpace: "نام فضای تبلیغاتی خود را وارد کنید",

      loading: false,
      loadingAdd: false,

      // add new category
      category: {},
    };
  },

  mounted() {
    this.fetch();
  },

  watch: {
    addSpace(val) {
      if (!val) {
        this.spaceId = null;
        this.oneTab = null;
        this.e1 = 1;
      }
    },
    spaces: {
      immediate: true,
      deep: true,
      handler(val) {
        localStorage.setItem("json", JSON.stringify(val));
      },
    },
    editSpace(val) {
      this.e1 = 1;
    },
  },

  methods: {
    addSpaceFun(e) {
      if (e == "submit") {
        if (this.nameSpace.length > 0) {
          const space = {
            name: this.nameSpace,
            image: this.picture,
            items: [],
          };
          this.loading = true;
          this.$api
            .post(`/v1/commercial/banner/category/${this.value}`, space)
            .then(({ data }) => {
              this.spaces.push({
                id: data.data.id,
                name: data.data.name,
                image: data.data.image,
                items: data.data.items,
              });
              this.category = {
                id: data.data.id,
                name: data.data.name,
                image: data.data.image,
                items: data.data.items,
              };
              this.nameSpace = "";
              this.fetch();
              this.$toast.success("دسته بندی جدید ایجاد شد");
              this.editSpace = true;
              this.oneTab = this.spaces.length - 1;
              this.picture = "";
            });
        } else {
          this.addSpace = false;
          this.$toast.error("نام دسته بندی نمیتواند خالی باشد");
          setTimeout(() => {
            this.addSpace = true;
          }, 2000);
        }
      } else return;
    },
    editName() {
      this.loading = true;
      this.$api
        .post(`/v1/commercial/banner/category/${this.value}`, this.category)
        .then(({ data }) => {
          this.$toast.success("تغییر با موفقیت انجام شد");
          this.fetch();
          this.loading = false;
        })
        .catch((err) => {
          this.$toast.error("مشکل پیش آمده است");
          this.fetch();
        });
    },
    addZSpaceFun(e) {
      if (e == "submit") {
        if (this.nameSpaceTwo.length > 0) {
          try {
            this.spaces.forEach((item) => {
              if (item.id === this.spaceId) {
                item.items.push({
                  id: item.items.length + 1,
                  active: false,
                  name: this.nameSpaceTwo,
                  image: this.picture,
                  information: {
                    size: null,
                    rentDay: null,
                    discription: null,
                  },
                  pay: {
                    day: 0,
                    week: 0,
                    month: 0,
                    threeMonth: 0,
                    sixMonth: 0,
                    year: 0,
                  },
                });
              }
            });
            this.nameSpaceTwo = "";
            this.spaceId = null;
            (this.picture = ""),
              this.$toast.success(" فضای تبلیغاتی شما با موفقیت اضافه شد");
          } catch {
            this.$toast.error("مشکلی پیش آمده است لطفا دوباره تلاش کنید");
          }
        } else {
          this.addSpace2 = false;
          this.$toast.error("نام فضای تبلیغاتی نمیتواند خالی باشد");
          setTimeout(() => {
            this.addSpace2 = true;
          }, 1500);
        }
      } else {
        this.nameSpaceTwo = "";
        this.spaceId = null;
      }
    },
    rulesSetting(type, v, item) {
      switch (type) {
        case "day": {
          return v > 0 || v == null
            ? null
            : "مقدار پرداخت روزانه نمیتواند صفر باشد";
        }
        case "week": {
          return v > 0 && v > item.day
            ? null
            : "مقدار پرداخت هفتگی نمیتواند خالی یا کمتر از مبالغ قبلی  باشد";
        }
        case "month": {
          return v > 0 && v > item.day && v > item.week
            ? null
            : "مقدار پرداخت ماهانه نمیتواند خالی یا کمتر از مبالغ قبلی کمتر  باشد";
        }

        case "threeMonth": {
          return v > 0 && v > item.day && v > item.month && v > item.week
            ? null
            : "مقدار پرداخت سه ماهه نمیتواند خالی یا از مبالغ قبلی کمتر باشد";
        }
        case "sixMonth": {
          return v > 0 &&
            v > item.day &&
            v > item.month &&
            v > item.threeMonth &&
            v > item.week
            ? null
            : "مقدار پرداخت شش ماهه نمیتواند خالی یا از مبالغ قبلی کمتر باشد";
        }
        case "year": {
          return v > 0 &&
            v > item.day &&
            v > item.month &&
            v > item.threeMonth &&
            v > item.sixMonth &&
            v > item.week
            ? null
            : "مقدار پرداخت سالیانه نمیتواند خالی یا از مقدار قبلی کمتر باشد";
        }
      }
    },
    async deleteSpaceOne(id) {
      if (
        await this.$modal.yesNo("آیا از حذف فضای تبلیغاتی خود اطمینان دارید ؟")
      ) {
        // this.spaces = this.spaces.filter((item) => item.id !== id);
        // this.$toast.success("فضای تبلیغاتی شما با موفقیت حذف شد");
        this.loading = true;
        this.$api
          .delete(
            `/v1/commercial/banner/category/${this.value}/${this.category.id}`,
          )
          .then((data) => {
            this.$toast.success("دسته تبلیغاتی شما با موفقیت حذف شد ");
            this.fetch();
          })
          .catch((err) => {
            this.$toast.error("مشکلی پیش آمده است دوباره امتحان کنید");
            this.loading = false;
          });
      }
    },
    async deleteSpaceTwo(space, space2) {
      if (
        await this.$modal.yesNo(
          "آیا از حذف زیرفضای تبلیغاتی خود اطمینان دارید ؟",
        )
      ) {
        this.spaces = this.spaces.map((item) => {
          if (item.id === space) {
            return {
              ...item,
              items: item.items.filter((i) => i.id !== space2),
            };
          } else {
            return item;
          }
        });
      }
    },
    onStepperNewItem(e) {
      this.e1 = 2;
      this.editItem = {
        name: "",
        image: "",
        active: true,
        pay: {
          day: 1000,
          week: 2000,
          month: 3000,
          threeMonth: 4000,
          sixMonth: 5000,
          year: 6000,
        },
        information: {
          rentDay: null,
          size: null,
          discription: null,
        },
      };
    },
    async fetchToSpace() {
      //  this.loading = true;
      //   const data = [
      //     {
      //       name: "1",
      //       image: "",
      //       active: true,
      //       pay: {
      //         day: 1000,
      //         week: 2000,
      //         month: 3000,
      //         threeMonth: 4000,
      //         sixMonth: 5000,
      //         year: 6000,
      //       },
      //       information: {
      //         rentDay: "1",
      //         size: "1",
      //         discription: "1",
      //         category: { name: "dddd", id: 1, image: "" },
      //       },
      //     },
      //     {
      //       name: "1",
      //       image: "",
      //       active: true,
      //       pay: {
      //         day: 1000,
      //         week: 2000,
      //         month: 3000,
      //         threeMonth: 4000,
      //         sixMonth: 5000,
      //         year: 6000,
      //       },
      //       information: {
      //         rentDay: "1",
      //         size: "1",
      //         discription: "1",
      //         category: { name: "dddd", id: 2, image: "" },
      //       },
      //     },
      //     {
      //       name: "1",
      //       image: "",
      //       active: true,
      //       pay: {
      //         day: 1000,
      //         week: 2000,
      //         month: 3000,
      //         threeMonth: 4000,
      //         sixMonth: 5000,
      //         year: 6000,
      //       },
      //       information: {
      //         rentDay: "1",
      //         size: "1",
      //         discription: "1",
      //         category: { name: "dddd", id: 1, image: "" },
      //       },
      //     },
      //   ];
      //   const obj = {
      //     ...this.editItem,
      //     type: "online",
      //   };
      //   this.$api
      //     .post(`/v1/commercial/banner/${this.value}`, JSON.stringify(obj))
      //     .then(({ data }) => {
      //       this.spaces.forEach((space) => {
      //         if (data.data.information.category.id == space.id) {
      //           space.items.push(this.editItem);
      //         }
      //       });
      //       // console.log("data:", data.data.information.category.id);
      //       this.editItem = {};
      //       this.$toast.success(" فضای تبلیغاتی با موفقیت اضافه شده");
      //       this.e1 = 1;
      //       this.loading = false;
      //     })
      //     .catch((err) => {
      //       this.$toast.error("مشکلی پیش آمده است دوباره امتحان کنید");
      //       this.loading = false;
      //     });
      if (this.editItem.name.length > 0) {
        this.loading = true;
        const filterCategory = this.category.items.filter(
          (item) => item.id !== this.editItem.id,
        );
        const newItem = {
          ...this.category,
          items: [
            ...filterCategory,
            {
              ...this.editItem,
              image: this.editItem?.image,
              type: "online",
              active: this.editItem?.active ? 1 : 0,
            },
          ],
        };
        this.$api
          .post(`/v1/commercial/banner/category/${this.value}`, newItem)
          .then((data) => {
            this.$toast.success("فضای جدید با موفقیت اضافه/ویرایش شد");
            this.fetch();
            this.e1 = 1;
            this.picture = "";
          })
          .catch((err) => {
            this.$toast.error("مشکلی پیش آمده است دوباره امتحان کنید");
          });
      } else {
        this.$toast.error("نام فضای تبلیغاتی نمیتواند خالی باشد");
      }
    },
    async fetch() {
      let datas = [];
      this.loading = true;
      await this.$api
        .get(`/v1/commercial/banner/category/${this.value}`)
        .then(({ data }) => {
          this.spaces = data;
          this.loading = false;
        });

      // console.log(datas);

      // const item = datas.reduce((acc, item) => {
      //   const categoryId = item.information.category.id;
      //   if (!acc[categoryId]) {
      //     acc[categoryId] = [];
      //   }
      //   acc[categoryId].push(item);
      //   return acc;
      // }, {});

      // const ob = Object.keys(item);
      // const fil = ob.map((res) => {
      //   return {
      //     name: item[res][0].information.category.name,
      //     image: item[res][0].information.category.image,
      //     id: item[res][0].information.category.id,
      //     items: [...item[res]],
      //   };
      // });

      // this.spaces = fil;
    },
  },
};
</script>

<style scoped></style>
